(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["competition-hero"] && !Shopify.designMode) return;
  try {
    
$(".home-hero-slider").slick({
  arrows: true,
  dots: true,
  autoplay: true,
  autoplaySpeed: 8000,
  appendArrows: ".home-hero-slider-nav-wrapper",
  appendDots: ".home-hero-slider-dots-wrapper"
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero-slider"] && !Shopify.designMode) return;
  try {
    
$(".home-hero-slider").slick({
  arrows: true,
  dots: true,
  autoplay: false,
  autoplaySpeed: 8000,
  appendArrows: ".home-hero-slider-nav-wrapper",
  appendDots: ".home-hero-slider-dots-wrapper",
  infinite: true,
  adaptiveHeight: true
});

  } catch(e) { console.error(e); }
})();
})();
